export function setItem(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    // ignore
  }
}
